import { StoreRescheduleReason } from '../types';

export enum RESCHEDULE_REASON {
    SICK = 'sick',
    PERSONAL_EMERGENCY = 'personal_emergency',
    WORK_EMERGENCY = 'work_emergency',
    OTHER = 'other',
}

const RESCHEDULE_OPTIONS = [
    RESCHEDULE_REASON.SICK,
    RESCHEDULE_REASON.PERSONAL_EMERGENCY,
    RESCHEDULE_REASON.WORK_EMERGENCY,
    RESCHEDULE_REASON.OTHER,
];

const checkReasonExists = (reason?: string): boolean => {
    if (!reason) {
        return false;
    }
    return RESCHEDULE_OPTIONS.includes(reason as RESCHEDULE_REASON);
};

const getActiveReasons = (guestRescheduleReasons: StoreRescheduleReason[] = []): string[] => {
    const results = [];

    for (const reason of RESCHEDULE_OPTIONS) {
        if (guestRescheduleReasons.find((val) => reason === val.reasonCode)) {
            results.push(reason);
        }
    }

    return results;
};

const isOtherOptionSelected = (selectedOption: string): boolean => {
    if (selectedOption === RESCHEDULE_REASON.OTHER) return true;

    return false;
};

export { getActiveReasons, isOtherOptionSelected, checkReasonExists };
